<template>
  <div class="w-full">
    <DatatableReportV3
      ref="datatable"
      title="Billing Tool"
      :source="source"
      :config="config"
      :filters="filters"
      no-download
      bulk-select
      bulk-select-key="checkbox_row_value"
      :bulk-select-ids="selectedValues"
      @update:bulk-select-ids="handleUpdateBulkSelectIds"
    >
      <template #actions>
        <div class="md:ml-3">
          <Button
            text="Charge"
            :disabled="!selectedValues.length"
            @click="toggleConfirm"
          />
        </div>
      </template>
    </DatatableReportV3>
    <ActionConfirmationModal
      v-if="confirmModal"
      :modal-contents="modalContents"
      @hide-modal="toggleConfirm"
      @on-submit="handleCharge"
    />
  </div>
</template>

<script>
import { mapActions } from "vuex";
import { EventBus } from "@/lib/event_bus.js";

import Button from "@/components/Button.vue";
import ActionConfirmationModal from "@/Reports/ActionConfirmationModal.vue";
import DatatableReportV3 from "@/Reports/DatatableReportV3.vue";

export default {
  components: {
    DatatableReportV3,
    ActionConfirmationModal,
    Button
  },
  props: {
    source: {
      type: String,
      default: ""
    },
    filters: {
      type: Array,
      default: () => []
    },
    selectionSubmitLink: {
      type: String,
      default: null
    }
  },
  data() {
    return {
      selectedValues: [],
      confirmModal: false,
      config: {
        responsive: true,
        order: [[3, "desc"]],
        columns: [
          { data: "invoice", responsivePriority: 2 },
          { data: "job", responsivePriority: 6 },
          {
            data: "finalized_at",
            title: "Completed",
            responsivePriority: 4
          },
          { data: "customer", responsivePriority: 1 },
          { data: "customer_email", title: "Email", responsivePriority: 9 },
          { data: "customer_phone", title: "Phone", responsivePriority: 5 },
          {
            data: "location_name",
            title: "Location Name",
            orderable: false,
            responsivePriority: 11
          },
          {
            data: "service_address",
            title: "Service Address",
            orderable: false,
            responsivePriority: 10
          },
          {
            data: "last_payment",
            title: "Last Payment",
            searchable: false,
            responsivePriority: 12
          },
          {
            data: "payment_method",
            title: "Last Method",
            orderable: false,
            searchable: false,
            responsivePriority: 13
          },
          { data: "notes", searchable: false, responsivePriority: 14 },
          {
            data: "total",
            title: "Amount",
            className: "text-right",
            searchable: false,
            responsivePriority: 7
          },
          {
            data: "balance",
            className: "text-right",
            searchable: false,
            responsivePriority: 3
          },
          {
            data: "on_file",
            className: "text-center",
            title: "On File",
            filterName: "with_payment_method",
            orderable: false,
            searchable: false,
            responsivePriority: 8
          }
        ]
      }
    };
  },
  computed: {
    modalContents() {
      return {
        message: `Charging ${
          this.selectedValues.length > 1
            ? `these ${this.selectedValues.length} invoices`
            : "this invoice"
        } will attempt to collect payment with the payment method on file.`,
        title: "Confirm Charge",
        success_message:
          "Invoice(s) submitted for charge.  Please check the status in a few minutes.",
        hide_input: true
      };
    }
  },
  methods: {
    ...mapActions(["submitDatatableSelections"]),
    handleUpdateBulkSelectIds(ids) {
      this.selectedValues = ids;
    },
    handleCharge() {
      // Action expects a url to POST to and a data payload
      this.submitDatatableSelections({
        link: this.selectionSubmitLink,
        data: this.selectedValues
      }).then(() => {
        // Reset selected rows
        this.selectedValues = [];
        // Automatically refresh the datatable on success
        EventBus.$emit("refresh-datatable");
        window.notify.success(this.modalContents.success_message);
        this.toggleConfirm();
      });
    },
    toggleConfirm() {
      this.confirmModal = !this.confirmModal;
    }
  }
};
</script>

<style lang="scss" scoped>
:deep(.on-file-filter-width) {
  min-width: 70px;
}
</style>
